export class AliasName {
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	/** The Person_Alias.Id */
	id: number;
	fullName: string;
	applicantNotes : string;
	responseId:number;
	applicantReviewed : boolean;
	reviewedDate : Date;
	includeWithReport : boolean = true;
	addingNote : boolean = false;
	tableName : string;
	excludeFromReport : boolean;
}

export class CriminalRecord {
  addingNote : boolean = true;
  selected : boolean = true;
  orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	recordId: number;
	offenseId: number;
	jurisdiction: string;
	caseNumber?: number;
	recordFileDate?: Date;
	recordProvider: string;
	providerState: string;
	offenderName: string;
	offenderStreet: string;
	city: string;
	state: string;
	zipCode: string;
	eyeColor: string;
	gender: string;
	hairColor: string;
	height: string;
	race: string;
	weight: string;
	offenseDescription: string;
	offenseType: string;
	dob: string;
	dispositionDate?: Date;
	dispositionData: string;
	probation: string;
	confinement: string;
	statuteNumber: string;
	arrestingAgency: string;
	plea: string;
	fine: string;
	offenseFileDate?: Date;
	offenseDate?: Date;
	applicantNotes: string;
	responseId: number;
	applicantReviewed: boolean;
	reviewedDate?: Date;
	offenses: CriminalRecordOffense[];
	excludeFromReport : boolean;
	gridAlert : boolean;
	gridAlertNote : string;
}
export class CriminalRecordOffense {
	offenseDescription: string;
	offenseType: string;
	dispositionDate?: Date;
	dispositionData: string;
	probation: string;
	confinement: string;
	statuteNumber: string;
	arrestingAgency: string;
	plea: string;
	fine: string;
	offenseFileDate?: Date;
	applicantNotes: string;
	responseId: number;
	applicantReviewed: boolean;
	sentenceData: string;
	reviewedDate?: Date;
	details : CriminalDetail[];
	excludeFromReport : boolean;	
}

export class CriminalDetail{
	name:string;
	value : string;
	origin:string;
}

export class EvictionRecord {
	addingNote : boolean = false;
	selected : boolean = true;
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	responseDataId: number;
	offenderName: string;
	evictionRecordId: number;
	caseNumber: string;
	caseType: string;
	caseDisposition: string;
	caseComments: string;
	courtLocation: string;
	applicantNotes: string;
	plantiff: string;
	claimAmount: string;
	evictionReferenceId: string;
	judgementAmount: string;
	fileDate: string;
	addressLine: string;
	city: string;
	state: string;
	zipCode: string;
	responseId: number;
	applicantReviewed: boolean;
	reviewedDate?: Date;
	evictionNote: string;
	excludeFromReport : boolean;
}

export class PreviousAddress {
	addingNote : boolean;
	tableName : string;
	applicantNotes : string;
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	/** Person_Address.Id */
	id: number;
	countryCode: string;
	postalCode: string;
	region: string;
	city: string;
	street: string;
	dateFirstReported: string;
	dateLastReported: string;
	responseId:number;
	applicantReviewed : boolean;
	reviewedDate : Date;
	excludeFromReport : boolean;
	
	public get firstReported() : string {
		if(this.dateFirstReported != null && this.dateFirstReported.indexOf('/') < 0){
			// then its in the taz YYYYMMDD format
			let yr = this.dateFirstReported.substring(0,4);
			let mo = this.dateFirstReported.substring(4,6);
			let dy = this.dateFirstReported.substring(6,8);
			return `${yr}-${mo}-${dy}`;
		}else
		return this.dateFirstReported; 
	}
	public get lastReported() : string {
		if(this.dateLastReported != null && this.dateLastReported.indexOf('/') < 0){
			// then its in the taz YYYYMMDD format
			let yr = this.dateLastReported.substring(0,4);
			let mo = this.dateLastReported.substring(4,6);
			let dy = this.dateLastReported.substring(6,8);
			return `${yr}-${mo}-${dy}`;
		}else
		return this.dateLastReported; 
	}
}

export class ApplicantTaxLien {
	addingNote : boolean = false;
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	searchType: string;
	responseId: number;
	fullName: string;
	ssn: string;
	street: string;
	city: string;
	state: string;
	zipCode: string;
	filingId: number;
	plaintiff: string;
	caseNumber:string;
	filingGroupDesc: string;
	filingTypeDesc: string;
	courtDesc: string;
	filingState: string;
	filingDate: string;
	
	public get filingDateP() : string {
		if(this.filingDate != null && this.filingDate.indexOf('-') < 0){
			// then its in the taz YYYYMMDD format
			let yr = this.filingDate.substring(0,4);
			let mo = this.filingDate.substring(4,6);
			let dy = this.filingDate.substring(6,8);
			return `${yr}-${mo}-${dy}`;
		}else
		return this.filingDate; 
	}
	
	judgmentDate: string;
	assetAmount: number;
	liabilityAmount: number;
	judgmentAmount: number;
	initialDate: string;
	applicantReviewed: boolean;
	reviewedDate?: Date;
	applicantNotes: string;
	excludeFromReport : boolean;
}

export class SSNTrace {
	orderId: number;
	orderDate: Date;
	applicantId: number;
	referenceId: any;
	firstName: string;
	lastName: string;
	ssn: string;
	dOB?: Date;
	ssnState: string;
	ssnYear: string;
	deceased?: boolean;
	excludeFromReport : boolean;
}


export class ReferenceVerification {
	orderId : number;
	orderDate : Date;
	applicantId : number;
	referenceId : any;
	searchType : string;
	id : number;
	contactName :string;
	phone :string; 
	email :string;
	address1 :string;
	address2 :string; 
	city :string; 
	state :string; 
	country :string; 
	postalCode :string; 
	referenceType :string; 
	relationship :string; 
	forceCloseDate :Date;
	alternateOutcome :string; 
	agentName :string; 
	resultsDetails :string; 
	verifiedDate :Date; 
	verifiedById :string; 
	verifiedBySource :string; 
	verifiedByName :string; 
	verifiedByTitle :string; 
	verifiedByCallNumber :string; 
	resultResponse : string;
	excludeFromReport : boolean;
	notes : string;
}

export class EmploymentVerification {
	orderId : number;
	orderDate : Date;
	applicantId : number;
	referenceId : any;
	searchType : string;
	id : number;
	employer : string;
	employerVerified : boolean; 
	employerDiscovered : string; 
	address1 : string; 
	address1Verified : boolean;
	address1Discovered : string;
	address2 : string;
	city : string;
	cityVerified : boolean; 
	cityDiscovered : string;
	country : string;
	countryVerified : boolean;
	countryDiscovered : string; 
	title : string;
	titleVerified : boolean;
	titleDiscovered : string;
	reasonForLeaving : string;
	reasonForLeavingVerified : boolean;
	reasonForLeavingDiscovered : string;
	compensation : string;
	compensationVerified : boolean; 
	compensationDiscovered : string;
	bonus : string;
	bonusVerified : boolean;
	bonusDiscovered : string;
	employedFrom : string;
	employedFromVerified : boolean;
	employedFromDiscovered : string;
	employedTo : string;
	employedToVerified : boolean;
	employedToDiscovered : string;
	phone : string;
	state : string;
	postalCode : string;
	contractor : string;
	supervisor : string;
	supervisorContactInfo : string; 
	rehireEligibility : string;
	rehireEligibilityVerified : boolean;
	rehireEligibilityDiscovered : string;
	currentEmployment : string;
	currentEmploymentVerified : boolean;
	currentEmploymentDiscovered : string;
	contractType : string;
	contractTypeVerified : boolean;
	contractTypeDiscovered : string;
	forceCloseDate : Date;
	alternateOutcome : string;
	agentName : string;
	email : string;
	resultsDetails : string;
	comments : string;
	verifiedDate : Date;
	verifiedById : string;
	verifiedBySource : string;
	verifiedByName : string;
	verifiedByTitle : string;
	verifiedByCallNumber : string;
	resultResponse : string;
	excludeFromReport : boolean;
	notes : string;
}